<template>
  <div class="jin-form-edu">
    <el-form v-for="(form, i) in info.formList" :key="i" :ref="(info.template + i)" class="el-form-flex el-form-reduce" :model="form" :rules="info.rules">
      <Delete v-if="info.formList.length > 1" :fix-con="{type: 'online', tem: info, idx: i}" />
      <div class="title jin-m">
        <h3>教育经历</h3>
      </div>
      <Input v-model="form.school" label="毕业院校" prop="school" />
      <Select v-model="form.education" :options="info.education" label="学历" prop="education" />
      <Select v-model="form.education_type" :options="info.education_type" label="学历类型" prop="education_type" />
      <Input v-model="form.major" label="专业" prop="major" />
      <Date v-model="form.date" label="起止时间" prop="date" />
    </el-form>
  </div>
</template>

<script>

export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      time: []
    }
  },
  methods: {
    submitForm() {
      const status = []
      let curr = true
      this.info.formList.forEach((item, i) => {
        this.$refs[(this.info.template + i)][0].validate((valid) => {
          status.push(valid)
          if (status.length === this.info.formList.length) curr = status.every(item => item)
        })
      })
      return curr
    },
    resetForm() {
      this.info.formList.forEach((item, i) => {
        this.$refs[(this.info.template + i)][0].resetFields()
      })
      this.info.formList = [{ date: ['', ''] }]
    }
  }
}
</script>

<style lang="scss" scoped>
.jin-m {
  .jin-form-edu {
    padding: 13px 0;
  }
}
</style>

